// Component: Breadcrumb.jsx
// Purpose: DS breadcrumb trail for detail / drill-in pages. Shows the navigation
//          path ("Trade Accounts › Account Name") so users know where they are —
//          especially on mobile, where the sidebar isn't visible. Replaces ad-hoc
//          per-page back buttons with one consistent, tokenized affordance.
//
// Usage:
//   <Breadcrumb items={[
//     { label: "Trade Accounts", to: "/TradeAccounts" },
//     { label: account.account_holder_name },   // last item = current (not linked)
//   ]} />

import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "./Icon";

export const Breadcrumb = ({ items = [], className = "" }) => {
  const navigate = useNavigate();
  if (!items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className={`flex items-center flex-wrap gap-0.5 text-sm min-w-0 ${className}`}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <Icon name="chevron-right" size={16} className="text-fg-3 shrink-0" aria-hidden="true" />
            )}
            {isLast || !item.to ? (
              <span
                className={isLast ? "text-fg-1 font-medium truncate" : "text-fg-2"}
                aria-current={isLast ? "page" : undefined}
              >
                {item.label}
              </span>
            ) : (
              <button
                type="button"
                onClick={() => navigate(item.to)}
                className="text-fg-2 hover:text-fg-1 transition-colors whitespace-nowrap"
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
